'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

var Book = function Book(_ref) {
  var className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 26 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 26 : _ref$width;
  return _react2.default.createElement(
    'svg',
    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-book ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 26 26' },
    _react2.default.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { fill: color, d: 'M24.481,0.9998 C24.301,0.9998 24.116,1.0328 23.934,1.1028 L13.546,5.0978 C13.37,5.1658 13.185,5.1998 13,5.1998 C12.815,5.1998 12.63,5.1658 12.454,5.0978 L2.066,1.1028 C1.884,1.0328 1.7,0.9998 1.519,0.9998 C0.714,0.9998 0,1.6498 0,2.5218 L0,11.3078 L0,20.2638 C0,20.8928 0.388,21.4568 0.975,21.6828 L12.454,26.0978 C12.63,26.1658 12.815,26.1998 13,26.1998 C13.185,26.1998 13.37,26.1658 13.546,26.0978 L25.025,21.6828 C25.612,21.4568 26,20.8928 26,20.2638 L26,11.3078 L26,2.5218 C26,1.6498 25.286,0.9998 24.481,0.9998 M2,3.2198 L11.736,6.9648 C12.141,7.1208 12.566,7.1998 13,7.1998 C13.434,7.1998 13.859,7.1208 14.264,6.9648 L24,3.2198 L24,11.3078 L24,19.9348 L13,24.1658 L2,19.9348 L2,11.3078 L2,3.2198' }),
      _react2.default.createElement('path', { stroke: color, strokeWidth: '2', d: 'M13,6.3079 L13,25.3079' }),
      _react2.default.createElement('path', { fill: color, d: 'M4.5,10.7888 L4.5,9.2888 L10,11.4038 L10,12.9038 L4.5,10.7888 Z M4.5,15.7888 L4.5,14.2888 L10,16.4038 L10,17.9038 L4.5,15.7888 Z M22,10.7888 L16.5,12.9038 L16.5,11.4038 L22,9.2888 L22,10.7888 Z M22,15.7888 L16.5,17.9038 L16.5,16.4038 L22,14.2888 L22,15.7888 Z' })
    )
  );
};

Book.propTypes = _bcPropTypes.iconShape;

exports.default = Book;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Book/Book.js
// module id = 157
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16